import { ProgramType } from 'types';

import { isNextEnvironment } from './isNextEnvironment';

export const getRecheckLicenseUrl = (): string =>
  `${isNextEnvironment() ? 'https://sandbox.recheck.co' : 'https://recheck.co'}/signin/`;

export const RECHECK_LICENSE_LINK_TEXT = 'Add or update your TDLR license in Recheck';

// Mirrors the server's isSalesRepLicenseManagedByRecheck: the server ignores a typed license only in this case.
export function isSalesRepLicenseManagedByRecheck(
  state: string | undefined | null,
  programType: string | undefined | null,
  isFlagOn: boolean | undefined,
): boolean {
  return !!isFlagOn && state === 'TX' && programType === ProgramType.solar;
}
